function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2178 13.2142C18.2956 12.8214 18.3376 12.4154 18.3376 12C18.3376 11.5839 18.2956 11.1787 18.2178 10.7859L19.6225 9.62773C20.0138 9.30572 20.1141 8.74726 19.8613 8.30858L19.1854 7.13566C18.9318 6.69698 18.399 6.50564 17.9254 6.68298L16.2157 7.32466C15.6091 6.79265 14.9013 6.3773 14.1219 6.11207L13.8225 4.31068C13.7392 3.81056 13.3076 3.44421 12.8004 3.44421H11.4486C10.9423 3.44421 10.5106 3.81056 10.4274 4.31068L10.1279 6.11207C9.34855 6.3773 8.63997 6.79265 8.03406 7.32466L6.32446 6.68298C5.85078 6.50564 5.31721 6.69698 5.06442 7.13566L4.38851 8.30858C4.13573 8.74726 4.23606 9.30572 4.62652 9.62773L6.032 10.7859C5.95345 11.1787 5.91222 11.5839 5.91222 12C5.91222 12.4154 5.95345 12.8214 6.032 13.2142L4.62652 14.3723C4.23606 14.6943 4.13573 15.2528 4.38851 15.6915L5.06442 16.8644C5.31721 17.3031 5.85078 17.4944 6.32446 17.3171L8.03406 16.6754C8.63997 17.2074 9.34855 17.6227 10.1279 17.888L10.4274 19.6894C10.5106 20.1895 10.9423 20.5558 11.4486 20.5558H12.8004C13.3076 20.5558 13.7392 20.1895 13.8225 19.6894L14.1219 17.888C14.9013 17.622 15.6091 17.2074 16.2157 16.6754L17.9254 17.3171C18.399 17.4944 18.9318 17.3031 19.1854 16.8644L19.8613 15.6915C20.1141 15.2528 20.0138 14.6943 19.6225 14.3723L18.2178 13.2142Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4581 12C14.4581 13.2888 13.4135 14.3334 12.1247 14.3334C10.8366 14.3334 9.79126 13.2888 9.79126 12C9.79126 10.7112 10.8366 9.66663 12.1247 9.66663C13.4135 9.66663 14.4581 10.7112 14.4581 12Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "assets/media/icon-settings.f908f779.svg";
export { ForwardRef as ReactComponent };